import TR from 'utils/TR';
import Section from 'components/common/Section';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import useRect from 'hooks/common/useRect';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useReportAgpGraph from 'hooks/communication/useReportAgpGraph';

import 'chartjs-adapter-luxon';
import DAY_ZONE_TYPES from 'constants/DAY_ZONE_TYPES';
import GlocoseAnalysisTable from './GlocoseAnalysisTable';
import GLOCOSE_COLUMNS from 'constants/GLOCOSE_COLUMNS';
import WEEK_ZONE_TYPES from 'constants/WEEK_ZONE_TYPES';
import GlocoseTIRChart from './GlocoseTIRChart';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';

const agps = {
  0: { search_dv: 0, search_key: 0 },
  1: { search_dv: 1, search_key: 1 },
  2: { search_dv: 1, search_key: 2 },
  3: { search_dv: 1, search_key: 3 },
  4: { search_dv: 1, search_key: 4 },
  5: { search_dv: 1, search_key: 5 },
  6: { search_dv: 1, search_key: 6 },
  7: { search_dv: 1, search_key: 7 },
  8: { search_dv: 2, search_key: 1 },
  9: { search_dv: 2, search_key: 2 },
  10: { search_dv: 3, search_key: 1 },
  11: { search_dv: 3, search_key: 2 },
  12: { search_dv: 3, search_key: 3 },
  13: { search_dv: 3, search_key: 4 },
}

export default function GlocoseAnalysis(props) {
  const {
    duration,
    data,
    ...rest
  } = props || {};
  const {
    bld_sugr_analyze_day_list = [],
    bld_sugr_analyze_time_zone_list = [],
    bld_sugr_analyze_week_days_weekend_list = [],
  } = data;

  const hash = React.useMemo(() => {
    const total = {
      avg_bld_sugr: 0,
      cv: 0,
      day_tp_cd: 0,
      gmi: 0,
      high_bld_sugr: 0,
      low_bld_sugr: 0,
      tar: 0,
      tbr: 0,
      tir: 0,
    };
    bld_sugr_analyze_day_list.forEach(item => {
      const {
        avg_bld_sugr = 0,
        cv = 0,
        gmi = 0,
        high_bld_sugr = 0,
        low_bld_sugr = 0,
        tar = 0,
        tbr = 0,
        tir = 0,
      } = item;
      total.avg_bld_sugr += avg_bld_sugr;
      total.cv += cv;
      total.gmi += gmi;
      total.high_bld_sugr += high_bld_sugr;
      total.low_bld_sugr += low_bld_sugr;
      total.tar += tar;
      total.tbr += tbr;
      total.tir += tir;
    });
    bld_sugr_analyze_time_zone_list.forEach(item => {
      const {
        avg_bld_sugr = 0,
        cv = 0,
        gmi = 0,
        high_bld_sugr = 0,
        low_bld_sugr = 0,
        tar = 0,
        tbr = 0,
        tir = 0,
      } = item;
      // total.avg_bld_sugr += avg_bld_sugr;
      // total.cv += cv;
      // total.gmi += gmi;
      // total.high_bld_sugr += high_bld_sugr;
      // total.low_bld_sugr += low_bld_sugr;
      // total.tar += tar;
      // total.tbr += tbr;
      // total.tir += tir;
    });
    bld_sugr_analyze_week_days_weekend_list.forEach(item => {
      const {
        avg_bld_sugr = 0,
        cv = 0,
        gmi = 0,
        high_bld_sugr = 0,
        low_bld_sugr = 0,
        tar = 0,
        tbr = 0,
        tir = 0,
      } = item;
      // total.avg_bld_sugr += avg_bld_sugr;
      // total.cv += cv;
      // total.gmi += gmi;
      // total.high_bld_sugr += high_bld_sugr;
      // total.low_bld_sugr += low_bld_sugr;
      // total.tar += tar;
      // total.tbr += tbr;
      // total.tir += tir;
    });
    return {
      '전체': Object.keys(total).reduce((a, c) => ({
        ...a,
        // [c]: (total[c] / Math.max(1, (bld_sugr_analyze_day_list.length + bld_sugr_analyze_time_zone_list.length + bld_sugr_analyze_week_days_weekend_list.length))).toFixed(2),
        [c]: +(total[c] / Math.max(1, (bld_sugr_analyze_day_list.length))).toFixed(2),
      }), {}),
      ...bld_sugr_analyze_day_list.reduce((a, c) => ({
        ...a,
        [WEEK_DAY_COLUMNS[+c.day_tp_cd - 1]]: c,
      }), {}),
      ...bld_sugr_analyze_time_zone_list.reduce((a, c) => ({
        ...a,
        [DAY_ZONE_TYPES[+c.time_zone_tp_cd - 1]]: c,
      }), {}),
      ...bld_sugr_analyze_week_days_weekend_list.reduce((a, c) => ({
        ...a,
        [WEEK_ZONE_TYPES[+c.week_days_weekend_tp_cd - 1]]: c,
      }), {}),
    };
  }, [bld_sugr_analyze_day_list, bld_sugr_analyze_time_zone_list, bld_sugr_analyze_week_days_weekend_list]);
  const chartRef = React.useRef();
  const optionsRef = React.useRef();
  const backgroundColorRef = React.useRef();
  const highlightColorRef = React.useRef();
  const selectedColorRef = React.useRef();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [highlightIndex, setHighlightIndex] = React.useState(null);
  const selectedIndiceRef = React.useRef({});
  const hightlightIndiceRef = React.useRef({});

  const onClick = React.useCallback((e, list) => {
    const [item] = list;
    if (item) {
      if (!(item.index in selectedIndiceRef.current)) {
        Object.keys(selectedIndiceRef.current).forEach(index => {
          optionsRef.current.data.datasets[0].backgroundColor[index] = backgroundColorRef.current;
          delete selectedIndiceRef.current[index];
        });
        optionsRef.current.data.datasets[0].backgroundColor[item.index] = selectedColorRef.current;
        selectedIndiceRef.current[item.index] = true;
      } else {
        Object.keys(selectedIndiceRef.current).forEach(index => {
          optionsRef.current.data.datasets[0].backgroundColor[index] = backgroundColorRef.current;
          delete selectedIndiceRef.current[index];
        });
      }

      const name = GLOCOSE_COLUMNS[item.index];
      const unselectable = DAY_ZONE_TYPES.includes(name);
      if (!unselectable) {
        setSelectedIndex((i) => i === item.index ? null : item.index);
      }
      chartRef.current.update();
    }
  }, []);

  const onHover = React.useCallback((e, list) => {
    const [item] = list;
    if (!item) {
      Object.keys(hightlightIndiceRef.current).forEach(index => {
        if (index in selectedIndiceRef.current) return;
        optionsRef.current.data.datasets[0].backgroundColor[index] = backgroundColorRef.current;
      });
      chartRef.current.update();
      setHighlightIndex(() => null);
    } else if (!(item.index in selectedIndiceRef.current)) {
      optionsRef.current.data.datasets[0].backgroundColor[item.index] = highlightColorRef.current;
      chartRef.current.update();
      setHighlightIndex(() => item.index);
      hightlightIndiceRef.current[item.index] = true;
    }
  }, []);

  const containerRef = React.useRef();

  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const setAgp = Recoil.useSetRecoilState(AppStore.assets.agp);

  const [search_dv, setSearchDv] = React.useState(0);
  const [search_key, setSearchKey] = React.useState(null);
  const {
    requestReportAgpGraph,
  } = useReportAgpGraph();
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    if (!patient_no) return;
    const agp = agps[selectedIndex || 0];
    setAgp(() => ({ uninitialized: true }));
    requestReportAgpGraph({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      ...agp,
    }, (success, data) => {
      if (success) {
        setAgp(() => ({ list: data.agp_graph_list }));
      }
    });
  }, [period_end, period_start, search_dv, search_key, setAgp, selectedIndex, patient_no, requestReportAgpGraph]);

  return (
    <Section
      {...ex('GlocoseAnalysis', rest)}
      {...{
        ref: containerRef,
        // caption: T('혈당분석'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <GlocoseTIRChart {...{ hash, duration, data }} />
      <GlocoseAnalysisTable
        {...{
          selectedIndex,
          highlightIndex,
          optionsRef,
          chartRef,
          selectedIndiceRef,
          hightlightIndiceRef,
          selectedColorRef,
          highlightColorRef,
          backgroundColorRef,
          setSelectedIndex,
          setHighlightIndex,
          hash,
        }}
      />
    </Section >
  );
}
